<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M10.002 18.3369L10.002 6.66797"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M4.16748 10.002H1.66699C1.66699 12.2125 2.54514 14.3326 4.10825 15.8957C5.67135 17.4588 7.79138 18.3369 10.002 18.3369C12.2125 18.3369 14.3326 17.4588 15.8957 15.8957C17.4588 14.3326 18.3369 12.2125 18.3369 10.002H15.8364"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M10.0024 6.66797C11.3834 6.66797 12.5029 5.54846 12.5029 4.16748C12.5029 2.7865 11.3834 1.66699 10.0024 1.66699C8.62146 1.66699 7.50195 2.7865 7.50195 4.16748C7.50195 5.54846 8.62146 6.66797 10.0024 6.66797Z"
			:fill="computedFill"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconSupporter',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: '#68BC8D'
		},
		filled: {
			type: Boolean,
			default: false
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.3
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
